import { Dispatch } from 'react';
import { createContext } from 'use-context-selector';
import { PayloadAction } from 'typesafe-actions';
import { AccountDetailsState, AccountDetailsContextActionTypes } from './types';
import { defaultAccountDetailsState } from './defaultState';

const AccountDetailsContext = createContext<Partial<AccountDetailsState>>(defaultAccountDetailsState);
const AccountDetailsDispatchContext = createContext<
  Dispatch<PayloadAction<AccountDetailsContextActionTypes, any>> | undefined
>(undefined);

export { AccountDetailsContext, AccountDetailsDispatchContext };
